var _circle, _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.4095,
    cy: 21.5905,
    r: 20.8373,
    stroke: "url(#paint0_linear_4_88844)",
    strokeWidth: 1.50631
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5352 29.0612C26.5193 29.4918 26.8884 28.5896 26.8884 28.5896L29.4924 15.5083C29.4719 14.6266 28.2826 15.1597 28.2826 15.1597L13.7045 20.8803C13.7045 20.8803 13.0074 21.1263 13.0689 21.5569C13.1304 21.9875 13.684 22.1925 13.684 22.1925L17.3542 23.4227C17.3542 23.4227 18.4614 27.0519 18.6869 27.749C18.892 28.4256 19.0765 28.4461 19.0765 28.4461C19.2815 28.5281 19.4661 28.3846 19.4661 28.3846L21.8445 26.2317L25.5352 29.0612ZM26.1671 17.824C26.1671 17.824 26.6796 17.5165 26.6591 17.824C26.6591 17.824 26.7412 17.865 26.4746 18.1521C26.2286 18.3981 20.426 23.606 19.6469 24.3032C19.5854 24.3442 19.5444 24.4057 19.5444 24.4877L19.3188 26.4151C19.2778 26.6201 19.0113 26.6406 18.9497 26.4561L17.9861 23.2985C17.9451 23.1755 17.9861 23.0319 18.1091 22.9499L26.1671 17.824Z",
    fill: "url(#paint1_linear_4_88844)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_88844",
    x1: 46.8787,
    y1: -43.181,
    x2: -3.8676,
    y2: -42.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32E1F9",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385159,
    stopColor: "#564CEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_88844",
    x1: 30.5875,
    y1: 0.822339,
    x2: 11.2824,
    y2: 0.950158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32E1F9",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385159,
    stopColor: "#564CEC"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.b254dad5411266031a4c27896fa034d7.svg";
export { ForwardRef as ReactComponent };